// eslint-disable

import React, { useCallback, useMemo, useState, useEffect } from 'react'

import MaterialTableCustom from '../../../components/MaterialTableCustom'
import { useUpdateLeadTimes, useAddLeadTimes, useDeleteLeadTimes } from '../../../hooks/queries'

const AllLeadTimesTable = ({ data, refreshTableData }) => {
    const { mutateAsync: addLeadTimes } = useAddLeadTimes()
    const { mutateAsync: updateLeadTimes } = useUpdateLeadTimes()
    const { mutateAsync: deleteLeadTimes } = useDeleteLeadTimes()
    const [deliveryData, setVendorData] = useState(data)

    useEffect(() => {
        if (!data) return
        //MAPPING THROUGH THE DATA AND FORMATTING IT AS PER REQUIRED BY THE TABLE
        const new_data = data
            .sort((a, b) => new Date(a?.dateOfRecord) - new Date(b?.dateOfRecord))
            .map((d) => ({
                ...d,
                trackingNumber: d?.tracking?.trackingNumber,
                carrier: d?.tracking?.carrier,
                trackingStatus: d?.tracking?.status,
            }))
        setVendorData([...new_data])
    }, [data])

    const onRowAdd = useCallback(async (newData) => {
        await addLeadTimes(newData)
        refreshTableData()
    }, [])

    const onRowUpdate = useCallback(async (newData) => {
        await updateLeadTimes(newData)
        refreshTableData()
    }, [])

    const onRowDelete = useCallback(async (oldData) => {
        await deleteLeadTimes({ id: oldData.id })
        refreshTableData()
    }, [])

    const columns = useMemo(
        () => [
            { title: 'PN', field: 'partNumber' },
            { title: 'Description', field: 'description' },
            { title: 'Vendor Name', field: 'vendorName' },
            { title: 'Lead Time (weeks)', field: 'leadTime' },

        ],
        [],
    )
    return (
        <MaterialTableCustom
            title={'Lead Times Summary'}
            columns={columns}
            rowStyle={{
                fontSize: '12px',
                paddingTop: 0,
                paddingBottom: 0,
                height: 0,
            }}
            headerStyle={{
                marginTop: -5,
                paddingTop: 0,
                paddingBottom: 5,
            }}
            cellStyle={{
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                maxWidth: 135,
            }}
            data={deliveryData}
            options={{
                filtering: false,
                search: true,
                paging: false,
                actionsColumnIndex: 10,
                maxBodyHeight: '600px',
            }}
            editable={{
                onRowAdd,
                onRowUpdate,
                onRowDelete,
            }}
        />
    )
}

export default AllLeadTimesTable
